import React from 'react';
import { Modal } from 'antd';
import { client as apolloClient } from '@xbcb/apollo-client';
import { validateUsDrawbackClaimCbpQuery } from './usDrawbackClaim.query';

interface ValidateResult {
  canceled: boolean;
}

const MODAL_WIDTH = 500;
const LIST_STYLE: React.CSSProperties = { paddingLeft: 20, margin: 0 };

export const validateBeforeSubmit = async (
  claimId: string | undefined,
): Promise<ValidateResult> => {
  try {
    const { data } = await apolloClient.query({
      query: validateUsDrawbackClaimCbpQuery,
      variables: { id: claimId },
      fetchPolicy: 'network-only',
    });

    const { errors, warnings } = data?.validateUsDrawbackClaimCbp ?? {};

    if (errors?.length) {
      Modal.error({
        title: 'Validation failed',
        content: (
          <ul style={LIST_STYLE}>
            {errors.map((e: { field: string; message: string }, i: number) => (
              <li key={i}>
                {e.field}: {e.message}
              </li>
            ))}
          </ul>
        ),
        okText: 'Close',
        width: MODAL_WIDTH,
      });
      return { canceled: true };
    }

    if (warnings?.length) {
      return new Promise((resolve) => {
        Modal.confirm({
          title: 'Validation warnings',
          content: (
            <ul style={LIST_STYLE}>
              {warnings.map((w: { message: string }, i: number) => (
                <li key={i}>{w.message}</li>
              ))}
            </ul>
          ),
          okText: 'Submit anyway',
          cancelText: 'Cancel',
          width: MODAL_WIDTH,
          onOk: () => resolve({ canceled: false }),
          onCancel: () => resolve({ canceled: true }),
        });
      });
    }

    return { canceled: false };
  } catch {
    Modal.error({
      title: 'Validation error',
      content: 'Failed to validate claim. Please try again.',
      okText: 'Close',
    });
    return { canceled: true };
  }
};
